<template>
  <div class="breadcrumb">
    <template v-for="(item, index) in items">
      <FontAwesomeIcon
        v-if="index > 0"
        class="breadcrumb__arrow"
        :icon="['fal', 'angle-right']"
        :key="'arrow_' + index"
      />
      <BreadcrumbItem :value="item" :key="'item_' + index" />
    </template>
  </div>
</template>

<script>
import graphql from '@/api/graphql'
import BreadcrumbItem from './Item'

const BaseHandlers = {
  Project: {
    items: 2,
    handler(id) {
      return graphql.request(`query { Project(id: "${id}") { id, name } }`).then(data => [
        { title: this.$tc('project', 2), action: { name: 'projects' } },
        { title: data.Project.name, action: { name: 'project-dashboard', params: { id: data.Project.id } } },
      ])
    },
  },
  Residential: {
    items: 3,
    handler(id) {
      return graphql.request(`query { Residential(id: "${id}") { id, name, project { id, name } } }`).then(data => [
        { title: this.$tc('project', 2), action: { name: 'projects' } },
        {
          title: data.Residential.project.name,
          action: { name: 'project-dashboard', params: { id: data.Residential.project.id } },
        },
        { title: data.Residential.name, action: { name: 'residential-edit', params: { id: data.Residential.id } } },
      ])
    },
  },
  Page: {
    items: 1,
    handler(id) {
      return graphql.request(`query { Page(id: "${id}") { id, name } }`).then(data => [
        {
          title: (JSON.parse(sessionStorage.getItem(`page:category`)) || {}).label || this.$tc('page', 2),
          action: { name: 'pages' },
        },
        {
          title: data.Page.name,
          action: {
            name: 'page-dashboard',
            params: { id: data.Page.id },
          },
        },
      ])
    },
  },
}

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    base: {
      type: Object,
      default() {
        let routeBase = this.$path('$route.meta.breadcrumb')
        if (!routeBase) return

        return typeof routeBase === 'function' ? routeBase.call(this, this) : routeBase
      },
    },
  },
  watch: {
    base: {
      handler(val) {
        if (!val) return
        this.baseItems = Array(BaseHandlers[val.onModel].items)
          .fill(undefined)
          .map(x => ({ title: null }))
        BaseHandlers[val.onModel].handler
          .call(this, val.ref)
          .then(data => (this.baseItems = data))
          .catch(err => (this.baseItems = []))
      },
      immediate: true,
    },
  },
  data() {
    return {
      baseItems: [],
    }
  },
  computed: {
    items() {
      return [...this.baseItems, ...this.value]
    },
  },
  components: {
    BreadcrumbItem,
  },
}
</script>

<style lang="scss">
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 0.8em;

  &__arrow {
    margin: 0 0.5rem;
    opacity: 0.6;
  }
}
</style>
